import { graphQLMutation } from 'graphql/helpers'
import { createUserInteraction } from 'graphql/mutations'
import { IAdminUser } from 'types'

export const isAdmin = (id: string, admins: IAdminUser[]) => {
  return admins.find(admin => admin.user.id === id)
}

export const sortBy = (list: any[], key: string) => {
  return list.sort((a, b) => (a[key] > b[key] ? 1 : -1))
}

export const debounce = (func: Function, timeout?: number) => {
  let timer: number | undefined
  return (...args: any[]) => {
    const next = () => func(...args)
    if (timer) {
      window.clearTimeout(timer)
    }
    timer = window.setTimeout(next, typeof timeout === 'number' && timeout > 0 ? timeout : 300)
  }
}

export const createInteraction = (
  link: string,
  email: string,
  type: string = 'navigation',
  trigger: string = 'clicked',
  eventStage?: string,
  duration?: string
) => {
  // ignore these users
  if (email.match(/mvrk.co|civic-us.com/)) {
    return
  }
  graphQLMutation(createUserInteraction, {
    name: link,
    trigger,
    type,
    email,
    eventStage: eventStage === 'POSTEVENT' ? 'POST' : 'LIVE',
    duration
  })
}

export const getSharedAsset = (
  assetName: string,
  vodType: 'demos' | 'sessions' | 'eventReplay',
  assetType: 'posters' | 'monoliths' | 'thumbnails' | 'videos'
) => {
  return `${process.env.REACT_APP_VZ_SHARED}/${vodType}/${assetType}/${assetName}`
}
